module.exports = __webpack_public_path__ + "static/media/top-active-players-light-icon.5852a757.svg";